<template>
  <Vue2Pdf :filename="filename">
    <main class="mx-10 bg-white">
      <div
        class="flex flex-col justify-between mt-4 text-xs text-black border border-black">
        <div class="flex border-b border-black">
          <div class="flex-none w-1/3">
            <h1 class="p-2 text-base font-bold border-b border-black">Run Design & Layout</h1>
            <table class="table w-full m-2 text-left">
              <tr>
                <th class="pt-1">Run Name</th>
                <td>{{ run.name }}</td>
              </tr>
              <tr>
                <th class="pt-1">System</th>
                <td>{{ run.title }}</td>
              </tr>
              <tr>
                <th class="pt-1">Grate</th>
                <td>{{ run.grate }}</td>
              </tr>
              <tr>
                <th class="pt-1">Total Run Length</th>
                <td>{{ run.feet }} ft / {{ run.length }} m</td>
              </tr>
              <tr>
                <th class="pt-1">Overall Channel Depth</th>
                <td>{{ run.channel_depth }}</td>
              </tr>
            </table>
          </div>
          <!-- run -->
          <div class="flex-none w-1/3 p-2 border-l border-black">
            <span class="italic">Project</span>
            <h2 class="p-1 text-base">{{ project.title }}</h2>
            <table class="table w-full mx-2 text-left">
              <tr>
                <th class="pt-1">Project Address</th>
                <td>{{ project.address }}</td>
              </tr>
              <tr>
                <th class="pt-1">City</th>
                <td>{{ project.city }}</td>
              </tr>
              <tr>
                <th class="pt-1">State/Region</th>
                <td>{{ project.state }}</td>
              </tr>
              <tr>
                <th class="pt-1">Country</th>
                <td>{{ project.country }}</td>
              </tr>
              <tr>
                <th class="pt-1">Zip/Post Code</th>
                <td>{{ project.zipcode }}</td>
              </tr>
            </table>
          </div>
          <!-- project -->
          <div class="flex-none w-1/3 p-2 border-l border-black">
            <span class="italic">Prepared by</span>
            <table class="table w-full mx-2 text-left">
              <tr>
                <th class="pt-1">Name</th>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <th class="pt-1">Company</th>
                <td>{{ user.company }}</td>
              </tr>
              <tr>
                <th class="pt-1">Phone</th>
                <td>{{ user.phone }}</td>
              </tr>
              <tr>
                <th class="pt-1">Email</th>
                <td>{{ user.email }}</td>
              </tr>
              <tr>
                <th class="pt-1">Phone</th>
                <td>{{ user.phone }}</td>
              </tr>
              <tr>
                <th class="pt-1">Print Date</th>
                <td>{{ time }}</td>
              </tr>
              <tr>
                <th class="pt-1">Created</th>
                <td>{{ project.created_at }}</td>
              </tr>
              <tr>
                <th class="pt-1">Last Edit</th>
                <td>{{ project.updated_at }}</td>
              </tr>
            </table>
          </div>
          <!-- user -->
        </div>
        <!-- Run details-->

        <div class="w-full mx-auto overflow-hidden" style="height:320px; transform: scale(.80)">
          <drawing-image
            :is-mounted="isMounted"
            :plain-view="false"
            :run="run"
            :part="[]"
            :outlets="outlets"
            class=""
          />
        </div>
        <!-- Drawing -->

        <div>
          <div class="flex items-center justify-end">
            <div class="flex-none w-1/2" />
            <div class="flex-auto p-2 border-t border-l border-black">
              <div class="flex items-stretch gap-1">
                <div class="flex-none w-1/3 p-2 text-center border-2 border-blue-600">
                  <img class="mx-auto" :src="system.img" :alt="system.name" />
                  <p class="font-bold text-blue-600">{{ system.name }}</p>
                </div>
                <div class="flex-none w-1/3 p-2 text-center border-2 border-blue-600">
                  <img class="mx-auto" :src="grate.img" :alt="grate.name" />
                  <p class="font-bold text-gray-600">{{ grate.name }}</p>
                  <p class="text-gray-500">{{ grate.label }}</p>
                </div>
                <div class="flex-none w-1/3 p-2 text-center border-2 border-blue-600">
                  <img class="mx-auto" :src="outletType.img" :alt="outletType.name" />
                  <p class="font-bold text-blue-600">{{ outletType.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- summary -->

          <footer class="flex items-center bg-gray-100 border-t border-black">
            <div class="flex-auto p-2">
              <img :src="brand" alt="Logo" width="100" class="mx-auto" />
            </div>
            <div class="flex-none w-1/2 p-2">
              <p class="mt-2">For terms and warranties please see our product relevant catalog or visit <a :href="`https://${app.website}`" class="underline capitalize cursor-pointer" target="_blank">{{ app.website }}</a></p>
            </div>
            <div class="flex-auto p-2 text-right">
              1 / 1
            </div>
          </footer>
        </div>
        <!-- footer -->
      </div>
    </main>
  </Vue2Pdf>
</template>

<script>
import Vue2Pdf from '@/Shared/Vue2Pdf'
import DrawingImage from '../Runs/Drawings/Index'

export default {
  components: {
    Vue2Pdf,
    DrawingImage,
  },
  props:{
    app       : Object,
    run       : Object,
    project   : Object,
    system    : Object,
    grate     : Object,
    user      : Object,
    outletType: Object,
    outlets   : Object,
    brand     : String,
    time      : String,
    filename  : String,
  },
  data() {
    return {
      isMounted: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true
    }, 100)
  },
}
</script>

<style>
  html { background-color: rgba(250, 250, 250, 1); }
  body {
      font-size: 12px;
      font-family: 'quattrocento_sans', sans-serif; }
</style>
